import React, { useEffect } from "react";

export default function Shelters() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto">
      <div className="p-5">Shelters</div>
    </div>
  );
}
